import type {
  InsertColourPaletteMutation,
  Scalars,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import {
  InsertColourPaletteDocument,
  namedOperations,
} from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export interface InsertColourPaletteInput {
  Name: string;
  Settings: Scalars['jsonb']['input'];
}

export const useInsertColourPalette = createMutationHook({
  name: 'insertColourPalette',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.colourPalette.insert.mutationOptions({ onSuccess }),
  mapInput: (input: InsertColourPaletteInput) => input,
  invalidate: (trpc) => [
    trpc.frontend.colourPalette.getColourPalettes.queryKey(),
  ],
  mapResponse: (result: { Id: string }): InsertColourPaletteMutation => ({
    insert_colour_palette_one: { __typename: 'colour_palette', Id: result.Id },
  }),
  graphqlDocument: InsertColourPaletteDocument,
  graphqlVariables: (input: InsertColourPaletteInput) => ({
    Name: input.Name,
    Settings: input.Settings,
  }),
  refetchQueries: [namedOperations.Query.getColourPalettes],
});
